import { createFeatureSelector } from '@ngrx/store';

import { ListItem } from '®shared/reading-list/models';

export const STATE_FEATURE_SHARE_SHEET = 'shareSheet';

export interface ShareSheetState {
  currentItem: ListItem | null;
  resourceImage: string | null;
}

export const SHARE_SHEET_INITIAL_STATE: ShareSheetState = {
  currentItem: null,
  resourceImage: null,
};

export function getInitialShareSheetState(): ShareSheetState {
  return SHARE_SHEET_INITIAL_STATE;
}

export const selectShareSheetState = createFeatureSelector<ShareSheetState>(
  STATE_FEATURE_SHARE_SHEET,
);
